import type { RewardItem } from '../../domain/reward'
import { ChevronIcon, CoinsIcon, GiftIcon } from './Icons'
import { useI18n } from '../../i18n'

interface Props {
  reward: RewardItem | null
  coins: number
  hasRewards: boolean
  onOpen: () => void
}

export const RewardGoalCard = ({ reward, coins, hasRewards, onOpen }: Props) => {
  const { copy: { rewardGoal } } = useI18n()
  if (!reward) return <button className="reward-goal reward-goal--empty" type="button" onClick={onOpen}><span className="reward-goal__icon"><GiftIcon /></span><span className="reward-goal__content"><span className="eyebrow">{rewardGoal.next}</span><strong>{hasRewards ? rewardGoal.choose : rewardGoal.create}</strong><small>{rewardGoal.intro}</small></span><ChevronIcon className="reward-goal__chevron" /></button>

  const available = coins >= reward.cost
  const remaining = Math.max(0, reward.cost - coins)
  const progress = Math.min(100, Math.floor((coins / reward.cost) * 100))
  return <button className={available ? 'reward-goal reward-goal--available' : 'reward-goal'} type="button" onClick={onOpen}>
    <span className="reward-goal__icon"><GiftIcon /></span>
    <span className="reward-goal__content">
      <span className="eyebrow">{available ? rewardGoal.available : rewardGoal.next}</span>
      <span className="reward-goal__title"><strong>{reward.name}</strong><small>{coins} / {reward.cost} <CoinsIcon /></small></span>
      <span className="xp-track reward-goal__track"><i style={{ width: `${progress}%` }} /></span>
      <small>{available ? rewardGoal.redeemNow : `${remaining} ${rewardGoal.missing}`}</small>
    </span>
    <ChevronIcon className="reward-goal__chevron" />
  </button>
}
